import { css } from '@/styled-system/css';

export const dotStyles = css.raw({
  // oxlint-disable-next-line constellation/no-raw-spacing-values -- `width: 15px` falls between `350` (14px) and `400` (16px) on the numeric sizes scale
  width: '15px',
  // oxlint-disable-next-line constellation/no-raw-spacing-values -- `height: 15px` falls between `350` (14px) and `400` (16px) on the numeric sizes scale
  height: '15px',
  borderRadius: '15px',
  backgroundColor:
    'purple.400' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
  float: 'left',
  // oxlint-disable-next-line constellation/no-raw-spacing-values -- `marginTop: 3px` falls between `50` (2px) and `100` (4px) on the numeric spacing scale
  marginTop: '3px',
  marginRight: '200',
});
